import { NotificationProvider, Refine } from '@pankod/refine-core'
import { ReadyPage, ErrorComponent } from '@pankod/refine-antd'
import 'styles/antd.less'
import routerProvider from '@pankod/refine-react-router-v6'
import dataProvider from '@pankod/refine-nhost'
import { authProvider } from './authProvider'
import { NhostAuthProvider } from '@nhost/react-auth'
import { LoginPage } from './pages/login'
import { liveProvider } from '@pankod/refine-ably'
import { Ably } from '@pankod/refine-ably'
import { nhost, ablyClient } from 'utility'
import { Title, Header, Sider, Footer, Layout, OffLayoutArea } from 'components/layout'
import { GradeLevelList } from 'pages/grades_level'
import { MediumList } from 'pages/medium'
import { GradesList } from 'pages/grades'
import { SectionsList } from 'pages/sections'
import { CompetenciesList } from 'pages/competencies'
import { AspectsList } from 'pages/aspects'

import { ProductsList } from 'pages/products'
import { SubjectsList } from 'pages/subjects'
import { BloomLevelsList } from 'pages/bloom_levels'
import { DifficultyLevelList } from 'pages/difficulty_levels'
import { TestTracksList } from 'pages/testtracks'
import { WorkRequestsList, WorkRequestShow } from 'pages/workrequests'
import { ThemesList } from 'pages/themes'
import { SubThemesList } from 'pages/subthemes'
import { TopicsList } from 'pages/topics'
import { ReportThemesList } from 'pages/reportthemes'
import { TestEventsList, TestEventShow } from 'pages/testevents'
import { PaperTemplatesList, EditPaperTemplate, ClonePaperTemplate, PaperTemplateShow } from 'pages/paper_templates'

import { UserManagementList } from 'pages/users'
import { CentaConceptList } from 'pages/centaconcept'
import { TNTaxonomyList } from 'pages/tntaxonomy'
import { ExplanationTypeList } from 'pages/explanationtype'
import { TeacherLevelList } from 'pages/teacherlevel'
import { StrandList } from 'pages/strands'
import { CheckList } from 'pages/checklist'
import { ReportList } from 'pages/report/list'

import { QuestionsList, QuestionShow } from 'pages/questions'
import { CleanupListPage, CleanupQuestionShow } from './pages/cleanup'

import { Dashboard } from 'pages/dashboard'
import { ForgotPasswordPage } from 'pages/forgotpassword'
import { UpdateProfilePage } from 'pages/updateprofile'
import { ResetPasswordPage } from 'pages/resetpassword'
import { TestEventWorkRequestList, PaperRequestShow } from 'pages/paperrequests'
import { EditPaper, PapersList } from 'pages/papers'
import { ProductShow } from 'pages/products/show'
import { ShowPaper } from 'pages/papers/show'
import { DraftQuestionShow, DraftQuestionTableList } from 'pages/draftquestions'
import { Evaluation, ShowEvaluation } from 'pages/evaluations'
import { ShowEvaluationRequest, EvaluationRequests } from 'pages/evaluation_requests'
import { ChangePasswordPage } from 'pages/changepassword'
import { QuestionUploadList } from 'pages/uploaded_questions'
import { QuestionLogs } from 'pages/history_logs/question_logs'
import { RetireRuleList } from 'pages/retirerules'

import { UserProvider } from 'context/user'
import SupportTaskList from 'pages/support_tasks/list'
import { ShowTask, ViewTaskList } from 'pages/tasks'
import { SupportTaskShow } from 'pages/support_tasks'
import { RetiredQuestionList } from 'pages/retired_questions'
import ListConfigurations from 'pages/configurations/list'

import { NationalAverageList } from 'pages/national_average/list'
import CandidateReport from 'pages/candidateReport/ams_view_report'
import AiConfigList from 'pages/ai_configuration/list'
import { ProjectLists } from 'pages/project_setup'
import AllQuestionListPageWrapper from 'pages/all_questions/list'
import CandidateReportPreview from 'pages/candidateReport/ams_view_report_preview'
import ScorecardPdfDownload from 'pages/candidateReport/scorecardPdfDownload'

import { CandidatesList } from 'pages/candidates/list'
const notificationProvider: NotificationProvider = {
  open: () => { },
  close: () => { },
}

function App() {
  return (
    <NhostAuthProvider nhost={nhost}>
      <UserProvider>
        <Refine
          notificationProvider={notificationProvider}
          ReadyPage={ReadyPage}
          catchAll={<ErrorComponent />}
          dataProvider={dataProvider(nhost)}
          authProvider={authProvider}
          liveProvider={liveProvider(ablyClient)}
          liveMode="auto"
          LoginPage={LoginPage}
          DashboardPage={Dashboard}
          Title={Title}
          Header={Header}
          Sider={Sider}
          Footer={Footer}
          Layout={Layout}
          OffLayoutArea={OffLayoutArea}
          routerProvider={{
            ...routerProvider,
            routes: [
              {
                element: <LoginPage />,
                path: '/login',
              },

              {
                element: <ResetPasswordPage />,
                path: '/resetpassword',
              },
              {
                element: <ChangePasswordPage />,
                path: '/changepassword',
              },
              // the block below is for generating report individually using view report button
              {
                element: <CandidateReport />,
                path: '/candidatereport/:id',
              },
              {
                element: <CandidateReportPreview />,
                path: '/centascorecard/preview/:id',
              },
              {
                element: <ScorecardPdfDownload />,
                path: '/download/scorecard-pdf',
              },
            ],
          }}
          resources={[
            {
              name: 'work_requests',
              list: WorkRequestsList,
              show: WorkRequestShow,
            },

            { name: 'questions', list: QuestionsList, show: QuestionShow },
            { name: 'questions', list: DraftQuestionTableList, show: DraftQuestionShow, options: { route: '/draft_questions' } },
            { name: 'questions', list: QuestionUploadList, options: { route: '/uploaded_questions' } },

            { name: 'mediums', list: MediumList },
            { name: 'grade_levels', list: GradeLevelList },
            { name: 'grades', list: GradesList },
            { name: 'sections', list: SectionsList },
            { name: 'competencies', list: CompetenciesList },
            { name: 'competency_aspects', list: AspectsList },
            { name: 'products', list: ProductsList, show: ProductShow },
            { name: 'test_tracks', list: TestTracksList },
            { name: 'themes', list: ThemesList },
            { name: 'sub_themes', list: SubThemesList },
            { name: 'report_themes', list: ReportThemesList },
            { name: 'topics', list: TopicsList },
            { name: 'test_events', list: TestEventsList, show: TestEventShow },
            { name: 'subjects', list: SubjectsList },
            { name: 'blooms_levels', list: BloomLevelsList },
            { name: 'difficulty_levels', list: DifficultyLevelList },
            {
              name: 'paper_templates',
              list: PaperTemplatesList,
              edit: EditPaperTemplate,
              create: ClonePaperTemplate,
              show: PaperTemplateShow,
            },
            { name: 'National Average', list: NationalAverageList, options: { route: '/nationalaverage' } },
            { name: 'All Questions', list: AllQuestionListPageWrapper, options: { route: '/all-questions' } },
            { name: 'Ai Configurations', list: AiConfigList, options: { route: '/aiconfig' } },
            { name: 'Question Cleanup', show: CleanupQuestionShow, list: CleanupListPage, options: { route: '/cleanup', label: 'Question Cleanup' } },
            { name: 'papers', list: PapersList, edit: EditPaper, show: ShowPaper },
            { name: 'ForgotPasswordPage', list: ForgotPasswordPage },
            { name: 'ResetPasswordPage', list: ResetPasswordPage },
            { name: 'UpdateProfilePage', list: UpdateProfilePage },
            { name: 'users', list: UserManagementList },
            { name: 'centa_concepts', list: CentaConceptList },
            { name: 'tn_taxonomys', list: TNTaxonomyList },
            { name: 'explanation_types', list: ExplanationTypeList },
            { name: 'teacher_levels', list: TeacherLevelList },
            { name: 'strands', list: StrandList },
            { name: 'check_lists', list: CheckList },
            { name: 'paper_requests', list: TestEventWorkRequestList, show: PaperRequestShow },
            { name: 'report', list: ReportList },
            { name: 'evaluations', list: Evaluation, show: ShowEvaluation },
            { name: 'evaluation_requests', list: EvaluationRequests, show: ShowEvaluationRequest },
            { name: 'question_history', list: QuestionLogs },
            {
              name: 'support_tasks',
              list: SupportTaskList,
              show: SupportTaskShow,
              options: {
                route: 'support/tasks',
              },
            },
            {
              name: 'view_tasks',
              list: ViewTaskList,
              show: ShowTask,
              options: {
                route: 'tasks',
              },
            },
            { name: 'retire_rules', list: RetireRuleList },
            { name: 'retired_questions', list: RetiredQuestionList },
            { name: 'configurations', list: ListConfigurations },
            { name: 'candidates', list: CandidatesList },
            { name: 'national_average', list: NationalAverageList, options: { route: '/nationalaverage' } },
            { name: 'project setup', list: ProjectLists, options: { route: '/project-setup' } },
          ]}
        />
      </UserProvider>
    </NhostAuthProvider>
  )
}

export default App
